module.exports = "/packs/she_chan-903c979138cd705d329e769df5406dec.png";